import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-24 bg-cream" data-id="element-134">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="bg-white rounded-3xl p-8 md:p-16 shadow-xl border border-sage/10 text-center relative overflow-hidden" data-id="element-136">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-sage to-terracotta" data-id="element-137"></div>

          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center p-4 bg-sage/10 rounded-full mb-8" data-id="element-138">
            <ShieldCheck className="h-12 w-12 text-sage-dark" data-id="element-139" />
          </motion.div>

          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6 font-serif" data-id="element-140">
            Garantía de Satisfacción Total — 7 Días Sin Preguntas
          </h2>

          <div className="max-w-2xl mx-auto space-y-6 text-lg text-forest/80 leading-relaxed" data-id="element-141">
            <p data-id="element-142">
              Si por cualquier razón descargas PequeSalud Natural y sientes que
              no era lo que esperabas — escríbeme y te devuelvo cada centavo.
            </p>
            <p data-id="element-143">
              Sin formularios complicados. Sin preguntas incómodas. Sin demoras.
            </p>
            <p className="font-medium text-forest" data-id="element-144">
              Porque estoy 100% segura de que cuando la necesites de verdad — a
              las 2AM, con tu hijo con fiebre — vas a entender por qué la creé.
            </p>
            <p className="italic text-terracotta font-serif text-xl" data-id="element-145">
              "Si no es para ti, el riesgo es completamente mío."
            </p>
          </div>
        </div>
      </div>
    </section>;
}